
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class NavMenu extends Vue {
    private get permissions() {
        return this.$store.state.permissions;
    }
}
